module.exports = __webpack_public_path__ + "img/0Q3A4704_L_Wood.5cb203b4.jpg";